/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Not_Found_TitleInputs */

const en_components_not_found_title = /** @type {(inputs: Components_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page not found`)
};

const de_components_not_found_title = /** @type {(inputs: Components_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seite nicht gefunden`)
};

const pt_br2_components_not_found_title = /** @type {(inputs: Components_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página não encontrada`)
};

const tr_components_not_found_title = /** @type {(inputs: Components_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sayfa bulunamadı`)
};

const zh_cn2_components_not_found_title = /** @type {(inputs: Components_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`页面未找到`)
};

const zh_hk2_components_not_found_title = /** @type {(inputs: Components_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`找不到頁面`)
};

const ko_kr2_components_not_found_title = /** @type {(inputs: Components_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`페이지를 찾을 수 없습니다`)
};

const ru_ru2_components_not_found_title = /** @type {(inputs: Components_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Страница не найдена`)
};

const es_419_components_not_found_title = /** @type {(inputs: Components_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página no encontrada`)
};

/**
* | output |
* | --- |
* | "Page not found" |
*
* @param {Components_Not_Found_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const components_not_found_title = /** @type {((inputs?: Components_Not_Found_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Not_Found_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_components_not_found_title(inputs)
	if (locale === "de") return de_components_not_found_title(inputs)
	if (locale === "pt-BR") return pt_br2_components_not_found_title(inputs)
	if (locale === "tr") return tr_components_not_found_title(inputs)
	if (locale === "zh-CN") return zh_cn2_components_not_found_title(inputs)
	if (locale === "zh-HK") return zh_hk2_components_not_found_title(inputs)
	if (locale === "ko-KR") return ko_kr2_components_not_found_title(inputs)
	if (locale === "ru-RU") return ru_ru2_components_not_found_title(inputs)
	return es_419_components_not_found_title(inputs)
});